// extracted by mini-css-extract-plugin
export default {"date":"date--30ZFm"};